import {fork} from 'redux-saga/effects';
import {combineReducers} from 'redux';

import {sagas as inviteS, reducer as inviteR} from './invite';
import {sagas as dealS, reducer as dealR} from './deals';
import {reducer as allocationR} from './allocations';

export function* sagas() {
  yield fork(inviteS);
  yield fork(dealS);
}

export const reducer = combineReducers({
  invites: inviteR,
  deals: dealR,
  allocations: allocationR,
});



// WEBPACK FOOTER //
// ./mobile/shared/api/index.js